<script lang="ts">
	import { Text, Icon } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let benefitSubscription: {
		details?: string;
		detailsValue?: number;
		icon?: string;
	};
	export let isPremium = false;

	let classes = classMap({
		'text-bold text-center': !benefitSubscription.icon,
		'text-color-muted': !isPremium,
		'icon-premium-color': isPremium,
	});
</script>

<div class="d-flex flex-direction-column height-full justify-content-center align-items-center">
	{#if typeof benefitSubscription.details !== 'undefined' && typeof benefitSubscription.detailsValue !== 'undefined'}
		<Text element="span" styleType="body-small" class={`${classes} mb-xxs`}>
			{benefitSubscription.detailsValue}
		</Text>
		<Text element="span" styleType="tiny" class={`${classes} text-500`}>
			{benefitSubscription.details}
		</Text>
	{:else}
		<Icon size="s" icon={benefitSubscription.icon + ` ${classes}`} />
	{/if}
</div>
